import {createContext,useContext,useEffect,useState} from 'react';
import {api,setCSRF} from './api';
const AppContext=createContext(null);
export const useApp=()=>useContext(AppContext);
export const AppProvider=({children})=>{
 const [user,setUser]=useState(null),[authLoading,setAuthLoading]=useState(true),[content,setContent]=useState(null),[contentError,setContentError]=useState(false);
 const refreshContent=()=>api.get('/public/content').then(r=>{setContent(r.data);setContentError(false)}).catch(()=>setContentError(true));
 useEffect(()=>{refreshContent();api.get('/auth/session').then(r=>{setUser(r.data.user);setCSRF(r.data.csrf)}).catch(()=>{}).finally(()=>setAuthLoading(false));},[]);
 const login=data=>{setUser(data.user);setCSRF(data.csrf)};
 const logout=async()=>{await api.post('/auth/logout');setUser(null);setCSRF('')};
 return <AppContext.Provider value={{user,authLoading,login,logout,content,contentError,refreshContent}}>{children}</AppContext.Provider>
};